import { ComboBox, type ComboBoxChangeEvent } from "@progress/kendo-react-dropdowns";
import type { SubBrandDto } from "../../../../contracts";

type SubBrandSelectorProps = {
    value: SubBrandDto | null;
    brandId: number | null;
    subBrands: SubBrandDto[];
    isFetching: boolean;
    disabled: boolean;
    onChange: (subBrandId: number | null) => void;
};

const SubBrandSelector: React.FC<SubBrandSelectorProps> = ({
    brandId,
    value,
    subBrands,
    isFetching,
    disabled,
    onChange
}: SubBrandSelectorProps) => {
    return (
        <div className="col-12">
            <label className="form-label small fw-semibold">
                Sub-brand
            </label>
            <ComboBox
                data={subBrands.filter(o => o.brand_id === brandId)}
                dataItemKey="id"
                textField="name"
                value={value}
                placeholder={brandId == null
                    ? "Select a brand first"
                    : isFetching
                        ? "Loading sub-brands..."
                        : "Select sub-brand"}
                disabled={disabled || brandId == null || isFetching}
                clearButton={true}
                style={{ width: "100%" }}
                onChange={(event: ComboBoxChangeEvent): void => {
                    const data: SubBrandDto | null = event.value;
                    onChange(data?.id ?? null);
                }}
            />
        </div>
    );
};

export default SubBrandSelector;
